import { authenticatedFetch } from "@/services/utils/authenticatedFetch";

export interface BlockbrainTestResult {
  ok: boolean;
  status?: number;
  error?: string;
  user?: unknown;
}

export async function testBlockbrainCredentials(payload?: {
  apiKey?: string;
  apiUrl?: string;
  botId?: string;
}): Promise<BlockbrainTestResult> {
  try {
    const response = await authenticatedFetch("/api/blockbrain-credentials/test", {
      method: "POST",
      body: JSON.stringify(payload || {}),
    });

    const json = (await response.json()) as BlockbrainTestResult;
    return json;
  } catch (error) {
    console.error("Error testing Blockbrain credentials:", error);
    return { ok: false, error: error instanceof Error ? error.message : String(error) };
  }
}
